/*
 Created by CHT 2019/9/18 9:33
 单选

  单选控件设置选项关联设计方案：
  1、每个控件增加两个字段：
     isRelateField 是否被单选控件设置了选项关联
     followShowList 是否有单选控件使自己显示
  2、在formSet的setConf方法中处理每个控件的isRelateField的值。（详情过程可去对应方法中查看）
  3、在单选控件选择选项时，处理每个控件的followShowList。（详情过程可去对应方法中查看）
  4、判断控件是否展示，在FillSectional类中，去get控件的followHidden，在followHidden的get方法中有两步判断
     4.1、判断isRelateField是否被单选控件设置了选项关联
     4.2、判断followShowList是否没有值
 */
import BaseItem from "../BaseItem"
import {
  DATA_TYPE__STRING,
  DEFAULT_VALUE__CUSTOM,
  DEFAULT_VALUE__RELATE_DATA,
  FORM_ITEM__SINGLE_CHOOSE, FORM_ITEM__TABLE,
  LAYOUT_TYPE__HOR,
  LAYOUT_TYPE__VER
} from "../types"
import {defaultValueInit, uuid} from "../utils"

class SingleChoose extends BaseItem {

  constructor() {
    super()
    this.options = [
      SingleChoose.createOption('选项1'),
      SingleChoose.createOption('选项2'),
      SingleChoose.createOption('选项3')
    ]

    this.value = ''
    this.relateField = 0 //是否关联其他控件显示
    this.layoutType = LAYOUT_TYPE__HOR
    this.showColor = 1
    this.defaultValue = {
      defaultType: ''
    }

    this.optColorChange = 0 // 本地标记opt颜色发生变化，不提交服务器

    this.selectOption = '' // 选择的option
    this.optionsType = 'custom' // custom 自定义，openApi，otherForm 关联其他表单数据， relateData 关联数据
  }

  get title() {
    return this.fieldTitle || SingleChoose._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

SingleChoose._title = '单选'
SingleChoose.type = FORM_ITEM__SINGLE_CHOOSE
SingleChoose.use = true
SingleChoose.icon = 'iconfont icon-iconfontoptionbutton'
SingleChoose.createOption = function (name) {
  return {
    optionName: name || '未命名',
    optionImage: '',
    chooseLimit: 20,
    defaultSelect: 0, // 是否默认选中
    alertText: '',  // 提示文案
    color: '#63B2EE',
    id: name || '未命名',
    fieldsMap: [] //选中后显示其他字段
  }
}
SingleChoose.prototype.type = SingleChoose.type
SingleChoose.prototype.dataType = DATA_TYPE__STRING
SingleChoose.prototype.layoutTypeList = [
  {
    value: LAYOUT_TYPE__HOR,
    label: '水平'
  },
  {
    value: LAYOUT_TYPE__VER,
    label: '垂直'
  }
]
SingleChoose.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: '自定义',
    value: defaultValueInit(DEFAULT_VALUE__CUSTOM)
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  }
]
SingleChoose.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '等于任意一个',
    method: 'in'
  },
  {
    name: '不等于任意一个',
    method: 'nin'
  },
  {
    name: '包含',
    method: 'like'
  },
  {
    name: '不包含',
    method: 'unlike'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
SingleChoose.prototype.getValue = function () {
  if (this.selectOption === '其他' && !this.value) {
    return '其他'
  }
  return this.value
}
SingleChoose.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  // if (this.options.map(item => item.id).includes(val)) {
  //   this.value = val
  // } else {
  //   this.value = ''
  // }
  this.value = val || ''
}
SingleChoose.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    options: this.options,
    layoutType: this.layoutType,
    defaultValue: this.defaultValue,
    relateField: this.relateField,
    showColor: this.showColor,
    optionsType: this.optionsType
  }
}
SingleChoose.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (this.layoutTypeList.includes(opts.layoutType)) {
    this.layoutType = opts.layoutType
  }
  if (opts.options) {
    this.options = opts.options
  }
  if (opts.optionsType) this.optionsType = opts.optionsType
  this.relateField = opts.relateField || 0
  this.showColor = opts.showColor === 0 ? 0 : 1
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
      if (this.relateField === 1) {
        this.options.forEach(opt => {
          if (opt.optionName === this.defaultValue.customValue) {
            // 找出当前选择的选项关联的目标字段，给目标字段的followShowList中加入自己的Id
            opt.fieldsMap.forEach(fieldId => {
              let field = this.root.fields[fieldId]
              if (field) field.followShowList.push(`${this.dataId}_${opt.id}`)
            })
          }
        })
      }
    }
  }
}
SingleChoose.prototype.addOpt = function (name) {
  if (!name) {
    const names = this.options.map(item => item.optionName)
    for (let i = 1; i < 1000; i++) {
      const currentName = `选项${i}`
      if (!names.includes(currentName)) {
        name = currentName
        break
      }
    }
  }
  this.options.push(SingleChoose.createOption(name))
}
SingleChoose.prototype.valueToString = function (value) {
  value = value || this.value
  if (!value || !value.length) return ''
  // return this.options.filter(opt => opt.id === value)[0] ? this.options.filter(opt => opt.id === value)[0].optionName : ''
  return value
}
export default SingleChoose
